module.exports = __webpack_public_path__ + "static/media/71+90DCooAL._AC_SL1500_.b23c3e7a.jpg";